import { render } from "./quiz-answer.vue?vue&type=template&id=2cd6aa5b&ts=true"
import script from "./quiz-answer.vue?vue&type=script&lang=ts"
export * from "./quiz-answer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__